import React from "react"

import ReactMarkdown from "react-markdown"
import rehypeKatex from "rehype-katex"
import remarkGfm from "remark-gfm"
import remarkMath from "remark-math"

import classNames from "src/classNames"

import useScrollToBottom from "hooks/useScrollToBottom"

import "katex/dist/katex.min.css"

const remarkPlugins = [remarkGfm, remarkMath]
const rehypePlugins = [rehypeKatex]

export type CopilotMessage = {
  text: string
  fromUser: boolean
}

type MessageListProps = {
  messages: CopilotMessage[]
  copilotLabel: string
  userLabel?: string
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  copilotLabel,
  userLabel = "You",
}) => {
  const scrollRef = useScrollToBottom<HTMLDivElement>(messages.length)

  return (
    <div
      ref={scrollRef}
      className="min-h-0 flex-1 space-y-3 overflow-y-auto px-3 py-3"
    >
      {messages.map((msg, i) => (
        <div
          key={i}
          className={classNames(
            "max-w-[85%] rounded-2xl px-3 py-2 shadow-md",
            msg.fromUser
              ? "ml-auto rounded-tr-none bg-sky-200 text-gray-900"
              : "rounded-tl-none bg-gray-200 text-gray-700"
          )}
        >
          <h4 className="text-lg font-bold">
            {msg.fromUser ? userLabel : copilotLabel}
          </h4>
          <div className="mt-1">
            <ReactMarkdown
              remarkPlugins={remarkPlugins}
              rehypePlugins={rehypePlugins}
            >
              {msg.text}
            </ReactMarkdown>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MessageList
